
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M187.628 0H43.707C19.607 0 0 19.607 0 43.707v143.921c0 24.1 19.607 43.707 43.707 43.707h143.921c24.1 0 43.707-19.607 43.707-43.707V43.707c0-24.1-19.607-43.707-43.707-43.707zM468.293 0H324.372c-24.1 0-43.707 19.607-43.707 43.707v143.921c0 24.1 19.607 43.707 43.707 43.707h143.921c24.1 0 43.707-19.607 43.707-43.707V43.707C512 19.607 492.393 0 468.293 0zM187.628 280.665H43.707C19.607 280.665 0 300.272 0 324.372v143.921C0 492.393 19.607 512 43.707 512h143.921c24.1 0 43.707-19.607 43.707-43.707V324.372c0-24.1-19.607-43.707-43.707-43.707zM468.293 280.665H324.372c-24.1 0-43.707 19.607-43.707 43.707v143.921c0 24.1 19.607 43.707 43.707 43.707h143.921c24.1 0 43.707-19.607 43.707-43.707V324.372c0-24.1-19.607-43.707-43.707-43.707z","fill":"gray","data-original":"#000000"}})])])
          )
        }
      }
    